// src/data/languages/coptic/categories/sentencesgap.ts
import { RevisionSentenceCollection } from '../../../../types/types';

// Collection de phrases pour la révision en copte basée sur les éléments grammaticaux
export const sentencesgap: RevisionSentenceCollection = {
  // Pronoms sujets
  "ⲁⲛⲟⲕ": [
    { original: "ⲁⲛⲟⲕ ϯⲛⲁϣⲉ ⲉϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Moi, je vais à l'église", english: "Me, I am going to church" },
    { original: "ⲁⲛⲟⲕ ϯⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ", french: "Moi, j'écoute la parole", english: "Me, I listen to the word" },
    { original: "ⲁⲛⲟⲕ ⲟⲩⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ", french: "Moi, je suis un homme bon", english: "Me, I am a good man" }
  ],
  "ⲛⲧⲟⲕ": [
    { original: "ⲛⲧⲟⲕ ⲭⲛⲁϣⲉ ⲉⲡⲓⲙⲱⲓⲧ", french: "Toi, tu vas sur le chemin", english: "You, you are going on the road" },
    { original: "ⲛⲧⲟⲕ ⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ", french: "Toi, tu écoutes le maître", english: "You, you listen to the teacher" },
    { original: "ⲛⲧⲟⲕ ⲟⲩⲣⲱⲙⲓ ⲛ̀ⲕⲟⲩϫⲓ", french: "Toi, tu es un petit homme", english: "You, you are a small man" }
  ],
  "ⲛⲧⲟϥ": [
    { original: "ⲛⲧⲟϥ ϥⲛⲁϣⲉ ⲉϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Lui, il va à l'église", english: "Him, he is going to church" },
    { original: "ⲛⲧⲟϥ ϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ", french: "Lui, il écoute le chant", english: "Him, he listens to the song" },
    { original: "ⲛⲧⲟϥ ⲟⲩⲥⲁϧ ⲛ̀ⲛⲓϣϯ", french: "Lui, il est un grand enseignant", english: "Him, he is a great teacher" }
  ],
  "ⲁⲛⲟⲛ": [
    { original: "ⲁⲛⲟⲛ ⲧⲉⲛⲛⲁϣⲉ ϧⲉⲛ ⲡⲓⲙⲱⲓⲧ", french: "Nous, nous allons sur le chemin", english: "Us, we are going on the road" },
    { original: "ⲁⲛⲟⲛ ⲧⲉⲛⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ", french: "Nous, nous écoutons la parole", english: "Us, we listen to the word" },
    { original: "ⲁⲛⲟⲛ ϩⲁⲛⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ", french: "Nous, nous sommes des hommes bons", english: "Us, we are good men" }
  ],

  // Conjugaison au présent
  "ϯⲥⲱⲧⲉⲙ": [
    { original: "ϯⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "J'écoute la parole dans l'église", english: "I listen to the word in church" },
    { original: "ϯⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ ⲛ̀ⲁⲅⲁⲑⲟⲥ", french: "J'écoute le bon enseignant", english: "I listen to the good teacher" },
    { original: "ϯⲥⲱⲧⲉⲙ ⲉⲣⲟⲕ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Je t'écoute sur le chemin", english: "I listen to you on the road" }
  ],
  "ⲕⲥⲱⲧⲉⲙ": [
    { original: "ⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ ⲛ̀ⲛⲓϣϯ", french: "Tu écoutes le grand enseignant", english: "You listen to the great teacher" },
    { original: "ⲕⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Tu écoutes le chant dans l'église", english: "You listen to the song in church" },
    { original: "ⲕⲥⲱⲧⲉⲙ ⲉⲣⲟⲓ ⲉⲓϯⲥⲃⲱ", french: "Tu m'écoutes quand j'enseigne", english: "You listen to me when I teach" }
  ],
  "ϥⲥⲱⲧⲉⲙ": [
    { original: "ϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ ⲛ̀ⲕⲟⲩϫⲓ", french: "Il écoute le petit chant", english: "He listens to the little song" },
    { original: "ϥⲥⲱⲧⲉⲙ ⲉⲛⲓⲣⲱⲙⲓ ϧⲉⲛ ⲡⲓⲙⲱⲓⲧ", french: "Il écoute les hommes sur le chemin", english: "He listens to the men on the road" },
    { original: "ϥⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ ⲛ̀ⲁⲅⲁⲑⲟⲥ", french: "Il écoute la bonne parole", english: "He listens to the good word" }
  ],

  // Conjugaison au passé
  "ⲁⲓⲥⲱⲧⲉⲙ": [
    { original: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ ⲛ̀ⲁⲅⲁⲑⲟⲥ", french: "J'ai écouté la bonne parole", english: "I listened to the good word" },
    { original: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲣⲟⲕ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Je t'ai écouté sur le chemin", english: "I listened to you on the road" },
    { original: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "J'ai écouté le maître dans l'église", english: "I listened to the teacher in church" }
  ],
  "ⲁⲕⲥⲱⲧⲉⲙ": [
    { original: "ⲁⲕⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲉϥϯⲥⲃⲱ ⲛ̀ⲛⲓϣϯ", french: "Tu as écouté le grand enseignant", english: "You listened to the great teacher" },
    { original: "ⲁⲕⲥⲱⲧⲉⲙ ⲉⲣⲟⲓ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Tu m'as écouté sur le chemin", english: "You listened to me on the road" },
    { original: "ⲁⲕⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ ⲛ̀ⲕⲟⲩϫⲓ", french: "Tu as écouté le petit chant", english: "You listened to the little song" }
  ],
  "ⲁϥⲥⲱⲧⲉⲙ": [
    { original: "ⲁϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ ⲛ̀ⲕⲟⲩϫⲓ", french: "Il a écouté le petit chant", english: "He listened to the little song" },
    { original: "ⲁϥⲥⲱⲧⲉⲙ ⲉⲣⲟⲕ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Il t'a écouté dans l'église", english: "He listened to you in church" },
    { original: "ⲁϥⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲱⲙⲓ ⲛ̀ⲡⲟⲛⲏⲣⲟⲥ", french: "Il a écouté le mauvais homme", english: "He listened to the bad man" }
  ],

  // Prépositions de base
  "ϧⲉⲛ": [
    { original: "ϯⲛⲁⲩ ⲉⲡⲓⲣⲱⲙⲓ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Je vois l'homme dans l'église", english: "I see the man in church" },
    { original: "ⲧⲉⲛϣⲗⲏⲗ ϧⲉⲛ ⲡⲓⲙⲁ ⲉⲑⲟⲩⲁⲃ", french: "Nous prions dans le lieu saint", english: "We pray in the holy place" },
    { original: "ⲁϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ ϧⲉⲛ ⲡⲓⲏⲓ", french: "Il a écouté le chant dans la maison", english: "He listened to the song in the house" }
  ],
  "ⲉ": [
    { original: "ⲧⲉⲛⲛⲁϣⲉ ⲉ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Nous allons à l'église", english: "We are going to church" },
    { original: "ⲁϥⲟⲩⲱⲣⲡ ⲛ̀ⲟⲩⲉⲡⲓⲥⲧⲟⲗⲏ ⲉ ⲡⲓⲣⲱⲙⲓ", french: "Il a envoyé une lettre à l'homme", english: "He sent a letter to the man" },
    { original: "ⲙⲁⲣⲉⲛϣⲉ ⲉ ⲡⲓⲙⲁ ⲛ̀ϣⲗⲏⲗ", french: "Allons au lieu de prière", english: "Let us go to the place of prayer" }
  ],
  "ϩⲓ": [
    { original: "ϯⲛⲁⲩ ⲉⲣⲟⲕ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Je te vois sur le chemin", english: "I see you on the road" },
    { original: "ⲡⲓⲣⲱⲙⲓ ⲟϩⲓ ⲉⲣⲁⲧϥ ϩⲓ ⲡⲓⲕⲁϩⲓ", french: "L'homme se tient sur la terre", english: "The man stands on the ground" },
    { original: "ⲁⲛⲟⲛ ⲧⲉⲛⲙⲟϣⲓ ϩⲓ ⲡⲓⲙⲱⲓⲧ ⲛ̀ⲛⲓϣϯ", french: "Nous marchons sur le grand chemin", english: "We walk on the great road" }
  ],

  // Adjectifs qualificatifs
  "ⲁⲅⲁⲑⲟⲥ": [
    { original: "ⲟⲩⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ ⲡⲉ", french: "C'est un homme bon", english: "He is a good man" },
    { original: "ⲡⲓⲣⲉϥϯⲥⲃⲱ ⲟⲩⲁⲅⲁⲑⲟⲥ ⲡⲉ", french: "Le maître est bon", english: "The teacher is good" },
    { original: "ϯⲛⲁⲩ ⲉⲟⲩⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ", french: "Je vois un homme bon", english: "I see a good man" }
  ],
  "ⲛⲓϣϯ": [
    { original: "ⲟⲩⲏⲓ ⲛ̀ⲛⲓϣϯ ⲡⲉ", french: "C'est une grande maison", english: "It is a big house" },
    { original: "ⲡⲓⲙⲱⲓⲧ ⲟⲩⲛⲓϣϯ ⲡⲉ", french: "Le chemin est grand", english: "The road is big" },
    { original: "ϯⲛⲁⲩ ⲉⲟⲩⲏⲓ ⲛ̀ⲛⲓϣϯ", french: "Je vois une grande maison", english: "I see a big house" }
  ],
  "ⲕⲟⲩϫⲓ": [
    { original: "ⲟⲩⲁⲗⲟⲩ ⲛ̀ⲕⲟⲩϫⲓ ⲡⲉ", french: "C'est un petit enfant", english: "It is a small child" },
    { original: "ⲡⲓⲏⲓ ⲟⲩⲕⲟⲩϫⲓ ⲡⲉ", french: "La maison est petite", english: "The house is small" },
    { original: "ϯⲛⲁⲩ ⲉⲟⲩⲁⲗⲟⲩ ⲛ̀ⲕⲟⲩϫⲓ", french: "Je vois un petit enfant", english: "I see a small child" }
  ],
  "ⲡⲟⲛⲏⲣⲟⲥ": [
    { original: "ⲟⲩⲣⲱⲙⲓ ⲙ̀ⲡⲟⲛⲏⲣⲟⲥ ⲡⲉ", french: "C'est un homme mauvais", english: "He is a bad man" },
    { original: "ⲡⲓⲗⲟⲅⲟⲥ ⲟⲩⲡⲟⲛⲏⲣⲟⲥ ⲡⲉ", french: "La parole est mauvaise", english: "The word is bad" },
    { original: "ϯⲛⲁⲩ ⲉⲟⲩⲣⲱⲙⲓ ⲙ̀ⲡⲟⲛⲏⲣⲟⲥ", french: "Je vois un homme mauvais", english: "I see a bad man" }
  ],

  // Combinaisons de structures grammaticales
  "ⲁⲛⲟⲕ_ϧⲉⲛ": [
    { original: "ⲁⲛⲟⲕ ϯⲥⲱⲧⲉⲙ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "Moi, j'écoute dans l'église", english: "Me, I listen in church" },
    { original: "ⲁⲛⲟⲕ ϯⲛⲁⲩ ⲉⲡⲓⲣⲱⲙⲓ ϧⲉⲛ ⲡⲓⲏⲓ", french: "Moi, je vois l'homme dans la maison", english: "Me, I see the man in the house" },
    { original: "ⲁⲛⲟⲕ ϯϣⲗⲏⲗ ϧⲉⲛ ⲡⲓⲙⲁ ⲉⲑⲟⲩⲁⲃ", french: "Moi, je prie dans le lieu saint", english: "Me, I pray in the holy place" }
  ],
  "ⲁⲓⲥⲱⲧⲉⲙ_ⲛⲓϣϯ": [
    { original: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓⲣⲱⲙⲓ ⲛ̀ⲛⲓϣϯ", french: "J'ai écouté le grand homme", english: "I listened to the great man" },
    { original: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ ⲛ̀ⲛⲓϣϯ", french: "J'ai écouté le grand chant", english: "I listened to the great song" },
    { original: "ⲁⲓⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ ⲛ̀ⲛⲓϣϯ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "J'ai écouté la grande parole dans l'église", english: "I listened to the great word in church" }
  ],
  "ⲛⲧⲟⲕ_ϩⲓ": [
    { original: "ⲛⲧⲟⲕ ⲭⲛⲁⲩ ⲉⲡⲓⲣⲱⲙⲓ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Toi, tu vois l'homme sur le chemin", english: "You, you see the man on the road" },
    { original: "ⲛⲧⲟⲕ ⲭⲟϩⲓ ⲉⲣⲁⲧⲕ ϩⲓ ⲡⲓⲕⲁϩⲓ", french: "Toi, tu te tiens sur la terre", english: "You, you stand on the ground" },
    { original: "ⲛⲧⲟⲕ ⲭⲛⲁⲩ ⲉⲡⲓⲁⲗⲟⲩ ⲛ̀ⲕⲟⲩϫⲓ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Toi, tu vois le petit enfant sur le chemin", english: "You, you see the small child on the road" }
  ],
  "ⲙⲓⲭⲁⲏⲗ_ⲕⲟⲩϫⲓ": [
    { original: "ⲡⲓⲁⲗⲟⲩ ⲙⲓⲭⲁⲏⲗ ⲟⲩⲕⲟⲩϫⲓ ⲡⲉ", french: "L'enfant Michel est petit", english: "The child Michael is small" },
    { original: "ⲁⲓⲛⲁⲩ ⲉⲙⲓⲭⲁⲏⲗ ⲡⲓⲁⲗⲟⲩ ⲛ̀ⲕⲟⲩϫⲓ", french: "J'ai vu Michel, le petit enfant", english: "I saw Michael, the small child" },
    { original: "ⲙⲓⲭⲁⲏⲗ ⲡⲓⲕⲟⲩϫⲓ ⲛ̀ⲁⲗⲟⲩ ϥⲥⲱⲧⲉⲙ ⲉⲡⲓϩⲱⲥ", french: "Michel, le petit enfant, écoute le chant", english: "Michael, the small child, listens to the song" }
  ],
  "ⲛⲓⲣⲱⲙⲓ_ⲁⲅⲁⲑⲟⲥ": [
    { original: "ⲛⲓⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ ⲥⲉⲙⲟϣⲓ ϩⲓ ⲡⲓⲙⲱⲓⲧ", french: "Les hommes bons marchent sur le chemin", english: "The good men walk on the road" },
    { original: "ⲁⲓⲛⲁⲩ ⲉⲛⲓⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ ϧⲉⲛ ϯⲉⲕⲕⲗⲏⲥⲓⲁ", french: "J'ai vu les hommes bons dans l'église", english: "I saw the good men in church" },
    { original: "ⲛⲓⲣⲱⲙⲓ ⲛ̀ⲁⲅⲁⲑⲟⲥ ⲥⲉⲥⲱⲧⲉⲙ ⲉⲡⲓⲗⲟⲅⲟⲥ", french: "Les hommes bons écoutent la parole", english: "The good men listen to the word" }
  ]
};

export default sentencesgap;
